<app-header [style]="'white'"></app-header>

<div class="section-wrapper">
  <div class="container">
    <div *ngIf="detail">
      <h1
        *ngIf="currentLang == 'en'"
        class="text-center"
        innerHTML="{{ detail.parsed_title.en }}"
      ></h1>
      <h1
        *ngIf="currentLang != 'en'"
        class="text-center"
        innerHTML="{{ detail.parsed_title.id }}"
      ></h1>

      <hr />

      <div class="img-wrapper mb-5">
        <img
          src="{{
            'https://weave.obs.ap-southeast-3.myhuaweicloud.com/news/desktop/' +
              detail.url_photo
          }}"
        />
      </div>

      <div
        *ngIf="currentLang == 'en'"
        [innerHTML]="detail.parsed_content.sanitized_en"
      ></div>
      <div
        *ngIf="currentLang != 'en'"
        [innerHTML]="detail.parsed_content.sanitized_id"
      ></div>
    </div>
  </div>
</div>

<app-footer></app-footer>
